<template>
	<div class="myProfileBasic">
		<!-- Tab content area -->
        <div class="c-common-space c-responsive-fixwidth c-common-box-shadow c-radius3">
            <div class="c-user-tab-content clearfix">
                <div class="col-md-6 table-td-border-right">

                    <div class="col-sm-12 o-no-padding">
                        <div class="col-md-5">
                            <h4 class="h4">{{ $t('nick_name') }}: </h4>
                        </div>
                        <div class="col-md-7">
                            <p class="h5-v1">{{userBasic.employable?userBasic.employable.display_name:""}}</p>
                        </div>
                    </div>

                    <div class="col-sm-12 o-no-padding">
                        <div class="col-md-5">
                            <h4 class="h4">{{ $t('seniority') }}: </h4>
                        </div>
                        <div class="col-md-7">
                            <p class="h5-v1">{{ userBasic&&userBasic.seniority?getRoundOffSkillSeniority(userBasic.seniority):"" }}</p>
                        </div>
                    </div>

                    <div class="col-sm-12 o-no-padding">
                        <div class="col-md-5">
                           <h4 class="h4">{{ $t('shift_count')}}:</h4>
                        </div>
                        <div class="col-md-7">
                           <p class="h5-v1">{{userBasic?userBasic.total_shifts:""}}</p>
                        </div>
                    </div>

                    <div v-for="(add,index) in (userBasic.employable)?userBasic.employable.addresses:[]" :key="index" class="col-sm-12 o-no-padding">
                   <div class="col-md-5">
                      <h4 class="h4">{{ $t('address')}}  {{ $t(add.label) }}:</h4>
                   </div>
                   <div class="col-md-7">
                       <p class="h5-v1">{{add.address+", "+add.municipality+", "+ add.postcode+", "+add.state_province+", "+add.country}}</p>
                   </div>
               </div>

                
                    <div class="col-sm-12 o-no-padding">
                        <div class="col-md-5">
                            <h4 class="h4">{{ $t('primary_email') }}:  </h4>
                        </div>
                        <div class="col-md-7">
                            <p class="h5-v1">{{userBasic.employable?userBasic.employable.email:""}}</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    
                    <div class="col-sm-12 o-no-padding">
                        <div class="col-md-5">
                            <h4 class="h4">{{ $t('secondary_email')}}</h4>
                        </div>
                        <div class="col-md-7">
                            <p class="h5-v1">{{userBasic.employable?userBasic.employable.secondary_email:""}}</p>
                        </div>
                    </div>
                    <div v-for="(phno,index) in (userBasic.employable)?userBasic.employable.phones:[]" :key="index" class="col-sm-12 o-no-padding">
                   <div class="col-md-5">
                       <h4 class="h4">{{ $t(phno.label) }}</h4>
                   </div>
                   <div class="col-md-7">
                       <p class="h5-v1">{{phno.phone_number}}</p>
                   </div>
               </div>
                   

                    <div class="col-sm-12 o-no-padding">
                        <div class="col-md-5">
                            <h4 class="h4">{{ $t('member_since') }}</h4>
                        </div>
                        <div class="col-md-7">
                          <p class="h5-v1">{{userBasic && userBasic.member_since?getDate(userBasic.member_since):""}}</p>
<!--                       <p class="h5-v1">{{userBasic?userBasic.member_since:""}}</p>-->
                        </div>
                    </div>
                    <div class="col-sm-12 o-no-padding">
                    <div class="col-md-5">
                        <h4 class="h4">{{ $t('date_of_hire') }}: </h4>
                    </div>
                    <div class="col-md-7">
                        <p class="h5-v1">{{(userBasic && userBasic.date_of_hire!=null)?getDate(userBasic.date_of_hire) : ""}}</p>
                    </div>
                </div>
                    <div class="col-sm-12 o-no-padding">
                        <div class="col-md-5">
                            <h4 class="h4">{{ $t('status') }}</h4>
                        </div>
                        <div class="col-md-7">
                            <p class="h5-v1">{{userBasic.employee_status?userBasic.employee_status.name:""}}</p>
                        </div>
                    </div>

                    <div class="col-sm-12 o-no-padding">
                        <div class="col-md-5">
                            <h4 class="h4">{{ $t('locals') }} </h4>
                        </div>
                       <div class="col-md-7">
                            <p class="h5-v1"></p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <!-- /Tab content area -->
        
	</div>
</template>
<script>
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import {
        global
    } from '../../global.js';
    import dateTimeConvert from '../../timeConvert&Compare';
    import service from '../../services.js';
    export default {
        props: {
            userProfile: {
                type: Object,
                required: true
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                currentEmployeeID: 'currentEmployeeID'
            })
        },
        data() {
            return {
                userBasic: "",
            }
        },
        watch: {
            userProfile: function(newData) {
                this.userBasic = newData;

            }
        },
        methods: {
            getRoundOffSkillSeniority(seniorityVal) {     
                // console.log(seniorityVal); 
                if(seniorityVal && seniorityVal != '') {          
                    if(seniorityVal.valueOf() == parseInt(seniorityVal)){
                        let x = parseInt(seniorityVal);
                        return x;
                    }
                }
                return seniorityVal;
            },
            getTime(dateTime) {
                return dateTimeConvert.localTime(dateTime);
            },
            getDate(dateTime) {
                return dateTimeConvert.localDate(dateTime);
            },
        },
        created() {
            this.userBasic = this.userProfile;
            //console.log("dddddd", this.userBasic);
        }
    }

</script>
